/**
 * region for libraries*/
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Typography, ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails } from '@material-ui/core';

/**
 * region for styles*/
import { productListKeywordStyle } from './style/productListKeywordStyle';

/**
 * region for icons*/
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

/**
 * region for hepers*/
import ajax from '../../helpers/ajax';
import Constants from '../../constants/Constants';

const _ = require('lodash')
class ProductListKeyword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            url: '',
            products: [],
            expanded: ''
        }
    }

    handleChangeExpand(panel, event, expand) {
        if (expand)
            this.setState({ expanded: panel });
        else
            this.setState({ expanded: 'none' });

    }

    urlProduct(idProductType, code, idproduct, idclient, idprofile) {
        let url = "";
        switch (idProductType) {
            case 8:
            case 6:
                url = "/Article_Modify.asp?code=" + code;
                break;
            case 3:
                url = "/Event_Modify.asp?code=" + code;
                break;
            case 5:
            case 9:
                url = "/Publication_Modify.asp?code=" + code;
                break;
            case 2:
            case 1:
            case 4:
            case 11:
                url = "/Extended_Product.asp?idproduct=" + idproduct + '&idclient=' + idclient + '&idprofile=' + idprofile;
                break;
            case 0:
                url = "/File_ContactMoment.asp?code=" + code;
                break;
            default:
                url = "/File_ContactMoment.asp?code=" + code;
                break;
        }
        return url;
    }

    load() {
        let self = this;

        let requestData = {
            idkeyword: self.props.keyword.IDKEYWORD
        };

        ajax.get(Constants.ROUTE_API_CONTENT_RELATED_CONTENT_BY_KEYWORD,
            {
                requestData: requestData,
                success: function (response) {
                    self.setState({ products: response.data });
                }
            });
    }
    componentDidMount() {
        this.loadUrlBase();
        this.load();
    }

    loadUrlBase() {
        let self = this;
        ajax.get(Constants.ROUTE_API_COMMONDATA,
            {
                success: function (response) {
                    let url = response.data.urlBackofficeBase;
                    self.setState({ url: url });
                }
            });
    }

    render() {
        let self = this;
        const { classes } = this.props;
        const groupsProducts = _.groupBy(self.state.products, 'IDPRODUCTTYPE');
        return (
            <div>
                {
                    Constants.PRODUCTTYPE.map((productType, index) =>
                        (groupsProducts[productType.idProductType] != null && groupsProducts[productType.idProductType].length > 0) && (<div key={index}>
                            <ExpansionPanel expanded={this.state.expanded === productType.name} onChange={this.handleChangeExpand.bind(this, productType.name)}>
                                <ExpansionPanelSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1bh-content"
                                    id="panel1bh-header">
                                    <Typography className={classes.heading}>{productType.name}</Typography>
                                </ExpansionPanelSummary>
                                <ExpansionPanelDetails>
                                    <div className={classes.inlineList}>
                                        {
                                            groupsProducts[productType.idProductType].map((product, index) =>
                                                <Typography variant="body2" key={index}>
                                                    <a rel="noopener noreferrer" href={self.state.url + this.urlProduct(product.IDPRODUCTTYPE, product.CODE, product.IDPRODUCT, product.IDCLIENT, product.IDPROFILE)} target="_blank">{product.IDCONTENT} - {product.TITLE}</a>
                                                </Typography>
                                            )
                                        }
                                    </div>
                                </ExpansionPanelDetails>
                            </ExpansionPanel>
                        </div>)
                    )
                }
            </div>
        );
    }
}
ProductListKeyword.propTypes = {
    classes: PropTypes.object.isRequired
};
export default withStyles(productListKeywordStyle)(ProductListKeyword);





